import React from "react";

import {
  Divider,
  Link,
  Typography,
  Span,
  FlexBox,
  Hidden,
  Button,
  GridContainer,
  Row,
  Column,
} from "@vp/swan";

import { editorDownloadEvent } from "../utils/tracking";
import { ResolvedSimpleLink } from "../../../types/ContentfulTypes";

interface PhotobooksInformationProps {
  offlineEditorMacDownload?: ResolvedSimpleLink;
  offlineEditorWindowsDownload?: ResolvedSimpleLink;
  designEditorDownloadInfo: string;
  compareEditors: string;
  productName: string;
  mpvId: string;
  coreProductId: string;
  onCompareEditorsClick: (event: React.MouseEvent<HTMLElement, MouseEvent>) => Promise<void>;
  trackingFunc: (eventName: string, callback: Function, counter?: number) => void;
}

const PhotobooksInformation = (props: PhotobooksInformationProps) => {
  const {
    offlineEditorMacDownload,
    offlineEditorWindowsDownload,
    designEditorDownloadInfo,
    compareEditors,
    productName,
    mpvId,
    coreProductId,
    onCompareEditorsClick,
    trackingFunc,
  } = props;

  const submitDownloadTracking = (label: string) => {
    editorDownloadEvent({
      btnLabel: label,
      mpvId,
      localizedProductName: productName,
      coreProductId,
      isFromTab: false,
      trackingFunc,
    });
  };

  const productPageTabId = "product-page-tabs";

  return (
    <Hidden sm xs>
      <Divider my={"7"} />
      <FlexBox justifyContent="space-evenly" flexDirection="column">
        <Typography fontWeight="bold" fontSize={"small"} mb={"5"}>
          {designEditorDownloadInfo}
        </Typography>
        <GridContainer>
          <Row>
            <Column span={6}>
              <Link
                width={"full-width"}
                skin={"unstyled"}
                href={offlineEditorMacDownload?.targetUrl}
                onClick={() => submitDownloadTracking("Mac Download")}
              >
                <Button width={"full-width"} className="mac-download-button" tabIndex={-1}>
                  <Span fontSize={"small"} fontWeight={"bold"}>
                    {offlineEditorMacDownload?.text}
                  </Span>
                </Button>
              </Link>
            </Column>
            <Column span={6}>
              <Link
                width={"full-width"}
                skin={"unstyled"}
                href={offlineEditorWindowsDownload?.targetUrl}
                onClick={() => submitDownloadTracking("Windows Download")}
              >
                <Button width="full-width" className="windows-download-button" tabIndex={-1}>
                  <Span fontSize={"small"} fontWeight={"bold"}>
                    {offlineEditorWindowsDownload?.text}
                  </Span>
                </Button>
              </Link>
            </Column>
          </Row>
        </GridContainer>
        <Link
          onClick={onCompareEditorsClick}
          href={compareEditors ? `#${productPageTabId}` : undefined}
          mt={"5"}
        >
          <Typography fontSize={"small"} textAlign="left">
            {compareEditors}
          </Typography>
        </Link>
      </FlexBox>
    </Hidden>
  );
};

export default PhotobooksInformation;
